
import CoughingAltSvgVue from "../components/svg/CoughingAltSvg.vue";
import PreferencesSvgVue from "../components/svg/PreferencesSvg.vue";
import InstructionSvgVue from "../components/svg/InstructionSvg.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  components: {
    appCouthingAltSvg: CoughingAltSvgVue,
    appPreferencesSvg: PreferencesSvgVue,
    appInstructionSvg: InstructionSvgVue,
  },
  computed: {
    appTitle: () => process.env.APP_TITLE,
  },
});
